<template>
	<div class="timetable" :style="removePageBreak ? 'page-break-inside: auto' : ''">
		<egranty-section-divider class="mt-4"
			text="Harmonogram"
			icon="date_range"
			:show-print-info="showPrintInfo"
		></egranty-section-divider>
		<div
			v-for="action in actions"
			:key=action.name
		>
			<v-card class="mt-1">

				<v-card-title style="background-color: #ABABAB"><h2>{{action.serialNumber}}. {{action.action}}</h2>
				</v-card-title>

				<v-card-text>
					<div
						v-for="(actionDate, index) in action.realizationDates"
						:key="actionDate.start + actionDate.end"
					>
						<v-layout row>
							<strong class="mr-3">{{1+index}}.</strong>
							<span>{{actionDate.start}} - {{actionDate.end}}</span>
						</v-layout>
					</div>
				</v-card-text>

			</v-card>
		</div>
	</div>
</template>

<script>
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";

	export default {
		name: "ContestOfferTimetable",
		components: {EgrantySectionDivider},
		props: {
			actions: {
				type: Array,
				default: () => [],
			},
			showPrintInfo: {
				type: Boolean, default: false
			},
			removePageBreak: {
				type: Boolean, default: false
			},
		},
	};
</script>

<style scoped>

</style>
